import { COMMON_QUERY_CONFIG, COMMON_VIDEO_QUERY_RULES_CONFIG } from './shared/configs';

enum SECTION_ENUM {
  VIDEO = 'Video'
}

const VIDEO = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_VIDEO_QUERY_RULES_CONFIG
  }
};

export { SECTION_ENUM, VIDEO };
